/**
* Case Studies JS
* -----------------------------------------------------------------------------
*
* All the JS for the Case Studies component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'case-studies',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let topOffset = 0;
      if ( $( '#wpadminbar' ).length ) {
        topOffset = $( '#wpadminbar' ).height();
      }

      $( '.case-studies' ).each( function( key, component ) {
        const splideBackground = new Splide( $( component ).find( '.splide--case-studies-background' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          height: window.innerHeight,
          autoHeight: true,
          direction: $( component ).attr( 'data-pin' ).length ? 'ttb' : 'ltr',
          perPage: 1,
          perMove: 1,
          speed: 1000,
          wheel: true,
          wheelSleep: 750,
          breakpoints: {
            768: {
              direction: 'ltr',
              autoHeight: false,
              wheel: false,
            },
          },
        } );

        const splideLinks = new Splide( $( component ).find( '.splide--case-studies-links' )[0], {
          type: 'loop',
          pagination: false,
          arrows: $( component ).attr( 'data-pin' ).length ? false : true,
          height: window.innerHeight,
          autoHeight: true,
          direction: $( component ).attr( 'data-pin' ).length ? 'ttb' : 'ltr',
          perPage: 1,
          perMove: 1,
          speed: 1000,
          wheel: $( component ).attr( 'data-pin' ).length ? true : false,
          wheelSleep: 750,
          breakpoints: {
            768: {
              direction: 'ltr',
              autoHeight: false,
              height: 'auto',
              wheel: false,
              pagination: false,
              arrows: false,
            },
          },
        } );

        const splideInfo = new Splide( $( component ).find( '.splide--case-studies-info' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          height: '236px',
          autoHeight: true,
          direction: $( component ).attr( 'data-pin' ).length ? 'ttb' : 'ltr',
          perPage: 1,
          perMove: 1,
          speed: 1000,
          wheel: true,
          wheelSleep: 750,
          breakpoints: {
            768: {
              direction: 'ltr',
              autoHeight: false,
              height: 'auto',
              wheel: false,
            },
          },
        } );

        const splideForeground = new Splide( $( component ).find( '.splide--case-studies-foreground' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          height: '236px',
          autoHeight: true,
          direction: $( component ).attr( 'data-pin' ).length ? 'ttb' : 'ltr',
          perPage: 1,
          perMove: 1,
          speed: 1000,
          wheel: true,
          wheelSleep: 750,
          breakpoints: {
            768: {
              direction: 'ltr',
              autoHeight: false,
              height: 'auto',
              wheel: false,
            },
          },
        } );

        splideBackground.on( 'mounted move', () => {
          addClassesToSlides( splideBackground );
        } );

        splideInfo.on( 'mounted move', () => {
          addClassesToSlides( splideInfo );
        } );

        splideForeground.on( 'mounted move', ( dest, index, prev ) => {
          if ( dest == null ) dest = 0;
          const adjustedDest = dest + 1;
          const formattedDest = adjustedDest < 10 ? '0' + adjustedDest : adjustedDest;

          $( '.splide-pagination .current-page' ).text( formattedDest );
          addClassesToSlides( splideForeground );
        } );

        splideForeground.on( 'mounted', () => {
          $( '.case-studies__inner' ).removeClass( 'opacity-0' );
          setTimeout( function() {
            $( '.splide--case-studies-info .splide__track' ).removeClass( 'opacity-0' );
          }, 500 );
        } );

        splideForeground.sync( splideBackground );
        splideForeground.sync( splideInfo );
        splideForeground.sync( splideLinks );
        splideForeground.mount();
        splideBackground.mount();
        splideLinks.mount();
        splideInfo.mount();

        function addClassesToSlides( slider ) {
          const current = slider.index;

          slider.Components.Elements.slides.forEach( ( slide, index ) => {
            slide.classList.remove( 'is-passed', 'is-upcoming', 'is-current' );

            if ( index < current ) {
              slide.classList.add( 'is-passed' );
            } else if ( index > current ) {
              slide.classList.add( 'is-upcoming' );
            } else {
              slide.classList.add( 'is-current' );
            }
          } );
        }
      } );

      // Link Cursor
      const zone = $( '.case-studies .cursor-zone' )[0];
      const cursor = $( '.case-studies .custom-cursor' )[0];
      const innerCursor = $( '.case-studies .custom-cursor__inner' )[0];

      let x = 0;
      let y = 0;
      let active = false;
      let escaped = false;

      zone.addEventListener( 'mouseenter', () => {
        active = true;
        cursor.style.opacity = 1;
        innerCursor.style.transform = `scale(1)`;
      } );

      zone.addEventListener( 'mouseleave', () => {
        active = false;
        escaped = false;
        zone.style.cursor = 'auto';
        innerCursor.style.transform = `scale(0)`;

        setTimeout( function() {
          cursor.style.opacity = 0;
        }, 200 );
      } );

      // Track mouse ONLY relative to the zone
      zone.addEventListener( 'mousemove', ( e ) => {
        const rect = zone.getBoundingClientRect();

        x = e.clientX - rect.left;
        y = e.clientY - rect.top;

        // Escape hatch check
        const escapeTarget = e.target.closest( '.native-cursor, .splide__arrows button' );

        if ( escapeTarget ) {
          escaped = true;
          cursor.style.opacity = 0;
          zone.style.cursor = 'auto';
        } else {
          escaped = false;
          cursor.style.opacity = 1;
          zone.style.cursor = 'none';
        }

        if ( active && !escaped ) {
          const maxRotation = 25;
          const vw = window.innerWidth;
          const rotateAmount = -maxRotation + ( x / vw ) * ( maxRotation * 2 );

          cursor.style.transform =
          `translate(${x}px, ${y}px) translate(-50%, -50%) rotate( ${rotateAmount}deg )`;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'case-studies', COMPONENT );
} )( app );
